import {BaseEntity} from "./BaseEntity";

export class ConfigSetting implements BaseEntity {
    constructor(public id?: number,
                public name?: string,
                public value?: string) {
    }

    parseJson(json: any): void {
        this.id = json.id;
        this.name = json.name;
        this.value = json.value;
    }
}
